export default "__VITE_ASSET__Bqw1Wdqv__"